.infiniteScroll {
  --scrollbar-track-width: 0.5rem;
  --scrollbar-track-background: var(--neutral);

  composes: scrollbar from '@/stylesheets/scrollbar.module.css';
}

.infiniteScroll {
  max-height: 100%;
  overflow: auto;
}
